import { useCreateMutation } from '../../CRUD';
import { axiosService } from '../../services/axiosService';
import { TNavigatePreviousQuestionParameters } from './types';

const useNavigatePreviousQuestion = () => {
  async function queryFn({
    customFormId,
  }: TNavigatePreviousQuestionParameters) {
    const { data } = await axiosService.put(
      `/v2/patientForms/${customFormId}/navigation`,
      { direction: 'back' },
    );

    return data;
  }

  return useCreateMutation(['navigatePreviousQuestion'], queryFn);
};

export default useNavigatePreviousQuestion;
